import types from "./types";

const INITIAL_STATE = {
	entities: [],
	loadingEntities: false,
	entitiesError: null,

	entityById: null,
	ruleForEntity: null,
	entityError: null,
	loadingEntity: false,

	ruleAdded: null,
	addingRule: false,
	addRuleError: null,

	ruleUpdated: null,
	updatingRule: false,
	updateRuleError: null,
};

const IdentificationRuleReducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		// Update rule related cases
		case types.UPDATE_RULE_FOR_ENTITY_START: {
			return {
				...state,
				ruleUpdated: null,
				updatingRule: true,
				updateRuleError: null,
			};
		}
		case types.UPDATE_RULE_FOR_ENTITY_SUCCESS: {
			return {
				...state,
				ruleUpdated: action.payload,
				updatingRule: false,
				updateRuleError: null,
			};
		}
		case types.UPDATE_RULE_FOR_ENTITY_ERROR: {
			return {
				...state,
				ruleUpdated: null,
				updatingRule: false,
				updateRuleError: action.payload,
			};
		}

		// Add rule related cases
		case types.ADD_RULE_FOR_ENTITY_START: {
			return {
				...state,
				ruleAdded: null,
				addingRule: true,
				addRuleError: null,
			};
		}
		case types.ADD_RULE_FOR_ENTITY_SUCCESS: {
			return {
				...state,
				ruleAdded: action.payload,
				addingRule: false,
				addRuleError: null,
			};
		}
		case types.ADD_RULE_FOR_ENTITY_ERROR: {
			return {
				...state,
				ruleAdded: null,
				addingRule: false,
				addRuleError: action.payload,
			};
		}

		// Get entity by id related cases
		case types.GET_ENTITY_BY_ID_START: {
			return {
				...state,
				entityById: null,
				entityError: null,
				loadingEntity: true,
			};
		}
		case types.GET_ENTITY_BY_ID_SUCCESS: {
			return {
				...state,
				entityById: action.payload,
				ruleForEntity: action.payload.rule,
				entityError: null,
				loadingEntity: false,
			};
		}
		case types.GET_ENTITY_BY_ID_ERROR: {
			return {
				...state,
				entityById: null,
				entityError: action.payload,
				loadingEntity: false,
			};
		}

		// Get entity list related cases
		case types.GET_ENTITY_LIST_START: {
			return {
				...state,
				entities: [],
				loadingEntities: true,
				entitiesError: null,
			};
		}
		case types.GET_ENTITY_LIST_SUCCESS: {
			return {
				...state,
				entities: action.payload,
				loadingEntities: false,
				entitiesError: null,
			};
		}
		case types.GET_ENTITY_LIST_ERROR: {
			return {
				...state,
				entities: [],
				loadingEntities: false,
				entitiesError: action.payload,
			};
		}

		// Defaulr case
		default: {
			return {
				...state,
			};
		}
	}
};

export default IdentificationRuleReducer;
